import { render, staticRenderFns } from "./mobile-account.vue?vue&type=template&id=53e87615&"
import script from "./mobile-account.vue?vue&type=script&lang=js&"
export * from "./mobile-account.vue?vue&type=script&lang=js&"
import style0 from "./mobile-account.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e87615')) {
      api.createRecord('53e87615', component.options)
    } else {
      api.reload('53e87615', component.options)
    }
    module.hot.accept("./mobile-account.vue?vue&type=template&id=53e87615&", function () {
      api.rerender('53e87615', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/header/mobile-account.vue"
export default component.exports